




























































































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { onlyNumber } from '@/utils/common'
import _ from 'lodash'

@Component

export default class ComponentRemuneracaoGeracaoRepasseRightNavBar extends Vue {
  fltLoading: boolean = false
  menu: boolean = false

  searchProfissional: string = ''
  searchPrestador: string = ''
  loadingProfissional: boolean = false
  loadingPrestador: boolean = false
  mensagemCompetencia: string = 'Selecione o Ano/mês referência para filtrar por profissional ou prestador'

  profissionaisDebounced = _.debounce((nome: string) => this.buscarProfissionais(nome), 500)
  prestadoresDebounced = _.debounce((filtro: string) => this.buscarPrestadores(filtro), 500)

  get status() {
    return this.getStore.statusList
  }

  get selectedTipo() {
    return this.getStore.selectedTipo
  }

  set selectedTipo(value) {
    this.getStore.setSelectedPrestador(value)
  }

  get getTiposList() {
    return this.getStore.tipoEnum
  }

  get filterLoading() {
    return this.fltLoading
  }

  set filterLoading(value: boolean) {
    this.fltLoading = value
  }

  get getStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get drawer() {
    return this.getStore.geracaoDrawer
  }

  set drawer(value: boolean) {
    this.getStore.setGeracaoDrawer(value)
  }

  get tipo() {
    return this.getStore.selectedTipo
  }

  set tipo(value: any) {
    this.getStore.setSelectedTipo(value.key)
  }

  get getMenu() {
    return this.menu
  }

  set getMenu(value: boolean) {
    this.menu = value
  }

  get anoMesReferencia() {
    return this.getStore.anoMesReferencia
  }

  set anoMesReferencia(value) {
    this.getStore.setAnoMesReferencia(value)
  }

  get temCompetencia() {
    return !!this.getStore.anoMesReferencia
  }


  get getProfissionaisList() {
    return this.getStore.geracaoProfissionaisOptions
  }

  get getPrestadoresList() {
    return this.getStore.geracaoPrestadoresOptions
  }

  get profissional() {
    return this.getStore.geracaoProfissionalFilter
  }

  set profissional(value: string) {
    this.getStore.setGeracaoProfissionalFilter(value || '')
  }

  get prestador() {
    return this.getStore.geracaoPrestadorFilter
  }

  set prestador(value: string) {
    this.getStore.setGeracaoPrestadorFilter(value || '')
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async search() {
    this.filterLoading = true
    this.getStore.setPaginaGeracao(1)
    await this.getStore.getGeracaoRepasseAll()
    this.getStore.setGeracaoFilterOn(this.hasAnyFilter())
    this.filterLoading = false
  }


  async selectTipo(item: any) {
    this.tipo = item
  }

  // Status fica fora: a tela nasce com um default (beforeMount), então ele nunca está vazio e
  // deixaria o "Limpar filtros" visível sempre.
  hasAnyFilter(): boolean {
    return this.getStore.selectedTipo.length > 0
      || !!this.getStore.fontePagadoraFilter
      || !!this.getStore.anoMesReferencia
      || !!this.getStore.geracaoProfissionalFilter
      || !!this.getStore.geracaoPrestadorFilter
  }

  async buscarProfissionais(nome: string) {
    await this.getStore.getGeracaoProfissionaisByNome(nome)
    this.loadingProfissional = false
  }

  async buscarPrestadores(filtro: string) {
    await this.getStore.getGeracaoPrestadoresByNome(filtro)
    this.loadingPrestador = false
  }

  // O nome do item escolhido volta como termo de busca; sem esse guarda o autocomplete refaz a
  // consulta a cada seleção.
  nomeDoSelecionado(items: any[], userId: string): string {
    const selecionado = items.find((item: any) => item.userId === userId)
    return selecionado ? selecionado.nome : ''
  }

  @Watch('searchProfissional')
  onSearchProfissionalChanged(value: string) {
    if (value && value === this.nomeDoSelecionado(this.getProfissionaisList, this.profissional)) return

    if (!value || value.length < 3) {
      if (!this.profissional) this.getStore.setGeracaoProfissionaisOptions([])
      return
    }

    this.loadingProfissional = true
    this.profissionaisDebounced(value)
  }

  @Watch('searchPrestador')
  onSearchPrestadorChanged(value: string) {
    if (value && value === this.nomeDoSelecionado(this.getPrestadoresList, this.prestador)) return

    if (!value || value.length < 3) {
      if (!this.prestador) this.getStore.setGeracaoPrestadoresOptions([])
      return
    }

    this.loadingPrestador = true
    this.prestadoresDebounced(value)
  }

  // Sem competência a API rejeita os dois filtros: limpa para não deixar filtro órfão aplicado.
  @Watch('anoMesReferencia')
  onAnoMesReferenciaChanged(value: string) {
    if (value) return

    this.profissional = ''
    this.prestador = ''
  }

  async clear() {
    this.getStore.clearFilterGeracaoRepasse()
    await this.search()
  }

  windowHeight: number = 0

  getWindowHeight() {
    const doc: Document = document

    if (doc !== null) {
      this.windowHeight = doc.documentElement.clientHeight
    }
  }

  async mounted() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
  }

  async updated() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
  }
}
